import React,{useState,useEffect} from 'react';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import FormControl from '@material-ui/core/FormControl';
import Ajax from './Ajax';
import {Inc,Play,EventParam} from "./Inc";
import {Styles} from './Styles';
import {Tools} from './Tools';
import Loading from './Loading';
import FourMeters from './FourMeters';
import Parameter from './Parameter';

interface Props {
    play:Play,
    param:EventParam,
    close(play:Play):void,
}

let selectedIndex = 0;

const EventRead = (props:Props)=> {
    const classes = Styles.base();
    const [states,setStates] = useState({
        newPlay: Inc.defaultPlay(),
        selected: false,
        finished: false,
        isLoading: false,
    })
    const read = (e: React.MouseEvent<HTMLElement>) =>{
        if( e.currentTarget.dataset.index ){
            selectedIndex = parseInt(e.currentTarget.dataset.index);
        } else {
            selectedIndex = 0;
        }
        setStates({...states,isLoading:true});
        Ajax.send("event/send",{play_id:props.play.id,selected:selectedIndex},(res:any)=>{
            if( res.ok ){
                setStates({...states,newPlay:res.play,isLoading:false,selected:true});
            }
        })
    }
    const close = ()=>{
        props.close(states.newPlay);
    }
    const finish = ()=>{
        setStates({...states,finished:true});
    }

    useEffect( ()=>{
        selectedIndex = 0;
    },[]);

    if( states.selected ){
        return (
            <div id="event_write">
                <div className={classes.room}>
                    採点した答案を机の引き出しに入れた<br/>
                </div>
                <div className={classes.meters}>
                    <FourMeters stWater={props.play.water} stMagenta={props.play.magenta} stCyan={props.play.cyan} stYellow={props.play.yellow} enWater={states.newPlay.water} enMagenta={states.newPlay.magenta} enCyan={states.newPlay.cyan} enYellow={states.newPlay.yellow} finish={finish}/>
                </div>
                {states.finished &&
                <div className={classes.modalBottom}>
                    <FormControl fullWidth={true} className={classes.formControl}>
                        <Button variant="outlined" color="primary" onClick={close}>{Tools.voice()}</Button>
                    </FormControl>
                </div>
                }
            </div>
        );    
    }

    return (
        <div id="event_write">
            <div className={classes.room}>
                ベッドと机のある部屋だ<br/>
                {Tools.lover(props.play,props.param)}の回答した答案が机の上に置かれている<br/>
            </div>
            <div className={classes.messageBoard}>
                <Typography variant="subtitle2">■回答</Typography>
                {props.param.message}
            </div>
            <div className={classes.modalBottom}>
                <FormControl fullWidth={true} className={classes.formControl}>
                    <Button variant="outlined" color="primary" onClick={read} data-index={1} style={{marginBottom:"0.2em"}}>マルをつける</Button>
                    <Button variant="outlined" color="primary" onClick={read} data-index={2} style={{marginBottom:"0.2em"}}>バツをつける</Button>
                </FormControl>
                <Parameter play={props.play}/>
            </div>
            <Loading isLoading={states.isLoading}/>
        </div>
    );
}

export default EventRead;
